var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 25,
    viewBox: "0 0 15 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.945312 23.1602L13.4453 21.6602",
    stroke: "currentColor",
    strokeWidth: 1.7,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4219 0.0800781V1.68066H14.0254V2.63672H12.4219V4.24023H11.4658V2.63672H9.86523V1.68066H11.4658V0.0800781H12.4219Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4453 9.28611H9.95889C9.88797 8.84884 9.75722 8.46149 9.56664 8.12403C9.37606 7.78183 9.13894 7.49191 8.85528 7.25426C8.57163 7.01662 8.24808 6.83839 7.88465 6.71957C7.52564 6.59599 7.13783 6.53421 6.72121 6.53421C5.98105 6.53421 5.32509 6.73383 4.75335 7.13306C4.1816 7.52755 3.73396 8.1074 3.41041 8.87261C3.08686 9.63307 2.92509 10.5622 2.92509 11.6602C2.92509 12.7771 3.08686 13.7181 3.41041 14.4834C3.73839 15.2438 4.18603 15.8189 4.75335 16.2086C5.32509 16.5936 5.97883 16.7861 6.71456 16.7861C7.12232 16.7861 7.50348 16.7291 7.85805 16.615C8.21706 16.4962 8.53839 16.3227 8.82204 16.0946C9.11013 15.8664 9.35168 15.586 9.5467 15.2533C9.74614 14.9206 9.88354 14.5404 9.95889 14.1126L12.4453 14.1269C12.3522 14.8208 12.1506 15.4719 11.8403 16.0803C11.5345 16.6887 11.1334 17.2257 10.637 17.6915C10.1406 18.1526 9.55999 18.5138 8.89517 18.7752C8.23035 19.0318 7.4924 19.1602 6.68132 19.1602C5.48465 19.1602 4.4165 18.8631 3.47689 18.269C2.53728 17.6749 1.79711 16.817 1.25639 15.6953C0.715673 14.5737 0.445312 13.2286 0.445312 11.6602C0.445312 10.087 0.717889 8.74191 1.26304 7.62499C1.80819 6.50331 2.55058 5.64542 3.49019 5.05132C4.4298 4.45721 5.49351 4.16016 6.68132 4.16016C7.43922 4.16016 8.14393 4.27422 8.79545 4.50236C9.44697 4.7305 10.0276 5.06558 10.5373 5.50759C11.047 5.94485 11.4658 6.48192 11.7938 7.11881C12.1262 7.75094 12.3434 8.47337 12.4453 9.28611Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCPlus);
export default __webpack_public_path__ + "static/media/c-plus.eaba4115d98386b106ae7fc3629bc9a0.svg";
export { ForwardRef as ReactComponent };